import React from "react";
import { Car } from "lucide-react";

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="relative mb-4">
          <Car className="w-12 h-12 text-primary-600 mx-auto animate-pulse" />
          <div className="absolute inset-0 w-12 h-12 border-2 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto"></div>
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Loading ride details...
        </h2>
        <p className="text-gray-600">
          Please wait while we fetch your ride information.
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
